import React from 'react';
import {View} from 'react-native';
import {createStackNavigator} from '@react-navigation/stack';

import TeamMembersList from './TeamMembersList';
import TeamMemberSingle from './TeamMemberSingle';
import {basicStyles} from '../../styles/basic';

const Stack = createStackNavigator();

function TeamMemberIndexEditNavigation(props) {
	return (

		<View style={basicStyles.flexScale}>
			<Stack.Navigator
				backBehavior="history"
				screenOptions={{
					header: () => null,
					cardStyle: {
						backgroundColor: '#F8FAFD'
					}
				}}
				initialRouteName="TeamMembersList"
			>
				<Stack.Screen
					name={"TeamMembersList"}
					component={TeamMembersList}
					options={{
						title: "Team"
					}}
				/>
				<Stack.Screen
					name={"TeamMemberEdit"}
					component={TeamMemberSingle}
					options={{
						title: "Team"
					}}
				/>
			</Stack.Navigator>
		</View>
	);
}

export default TeamMemberIndexEditNavigation;
